
export function CCCustomFooter(props) {
    return (<div className='px-4 py-4 flex flex-row text-ccColorDarkTeal'>
      <div className='flex grow'></div>
      <div>{props.titleCounter}: {props.counter}</div>
      
    </div>
    );
  }
  